// FIXME: this may be merged with ColumnsDropzone component
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);


const defaultProps = {
  description: '',
};
const propTypes = {
  isOver: PropTypes.bool.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

const ColumnsDropzone = ({
  isOver,
  description,
  children,
}) => (
    <div className={cx('dropzone', {
      hover: isOver,
      filled: !_.isEmpty(children) && children.length,
    })}
    >
      {_.isEmpty(children) ? description : children}
    </div>
  );

ColumnsDropzone.defaultProps = defaultProps;
ColumnsDropzone.propTypes = propTypes;
export default ColumnsDropzone;



// WEBPACK FOOTER //
// ./src/components/ui/Dropzones/BaseColumnsDropzone.jsx